import React from "react";
import { Row, Col } from "react-bootstrap";

import classes from "./ChatLoader.module.css";

export default function ChatLoader() {
  return (
    <Row>
      <Col xs="12" className={classes.head}>
        <div></div>
      </Col>
      <Row>
        <Col xs={{ span: "3" }} className={classes.sender}></Col>
        <Col
          xs={{ span: "3", offset: "9" }}
          className={classes.reciver + " mb-3"}
        />
      </Row>
      <Row>
        <Col xs={{ span: "6" }} className={classes.sender}></Col>
        <Col
          xs={{ span: "3", offset: "9" }}
          className={classes.reciver + " mb-3"}
        />
      </Row>
      <Row>
        <Col xs={{ span: "4" }} className={classes.sender}></Col>
        <Col
          xs={{ span: "5", offset: "7" }}
          className={classes.reciver + " mb-3"}
        />
      </Row>
      <Row>
        <Col xs={{ span: "3" }} className={classes.sender}></Col>
        <Col
          xs={{ span: "3", offset: "9" }}
          className={classes.reciver + " mb-3"}
        />
      </Row>
      <Row>
        <Col xs={{ span: "4" }} className={classes.sender}></Col>
        <Col
          xs={{ span: "5", offset: "7" }}
          className={classes.reciver + " mb-3"}
        />
      </Row>
      <Row>
        <Col xs={{ span: "3" }} className={classes.sender}></Col>
        <Col
          xs={{ span: "3", offset: "9" }}
          className={classes.reciver + " mb-3"}
        />
      </Row>
    </Row>
  );
}
